/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { routerActions } from 'react-router-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  Col,
  Panel,
  FormControl,
  Form,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';
import ActionButton from 'loracoms/ActionButton';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles/main.scss';
import { client } from '../../../helpers/ApiClient';

const propTypes = {
  intl: intlShape.isRequired,
  pushState: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
};

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitStatus: 'ready',
      password: null,
      RPassword: null,
      errmsgNPwd: null,
      errmsgRPwd: null,
    };
    this.newPwd = null;
    this.RepeatPwd = null;
    this.intlMsg = new IntlMsg(props.intl, 'resetpassword');
  }

  intlMsg(id, ns) {
    const nss = ns || 'resetpassword.new';
    return this.props.intl.formatMessage({
      id: `${nss}.${id}`,
      defaultMessage: `${nss}.${id}`,
    });
  }

  handleSave() {
    const data = { password: this.state.password, RPassword: this.state.RPassword };
    let pwdStatus = false;
    let RPwdStatus = false;
    if (data.password === null) {
      pwdStatus = true;
    }
    if (data.RPassword === null) {
      RPwdStatus = true;
    }
    if (!pwdStatus && !RPwdStatus) {
      this.setState({
        submitStatus: 'loading',
      });
      client.post('/account/reset', {
        data: { token: this.props.params.token, password: data.password },
      }).then(() => {
        this.setState({ submitStatus: 'success' });
        window.setTimeout(() => {
          this.props.pushState('/login');
        }, 2000);
      }, () => {
        this.setState({
          submitStatus: 'failed',
        });
      });
    } else {
      this.setState({
        errmsgNPwd: pwdStatus ? this.renderErrorTips(this.intlMsg.msg('new.password.error.null')) : null,
        errmsgRPwd: RPwdStatus ? this.renderErrorTips(this.intlMsg.msg('new.password.error.null')) : null,
      });
    }
  }

  handleChangeNewPwd(value) {
    if (value === undefined || value === '') {
      this.newPwd = null;
      this.setState({
        valid: false,
        errmsgNPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.null')),
        password: null,
      });
    } else {
      this.newPwd = value.toString();
      if (value.toString().length < 6 || value.toString().length > 16) {
        this.setState({
          valid: false,
          errmsgNPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.validerr')),
          password: null,
        });
      } else {
        this.setState({
          valid: true,
          errmsgNPwd: null,
          password: value,
        });
      }
      if (this.RepeatPwd !== null) {
        if (value === this.RepeatPwd) {
          this.setState({
            errmsgRPwd: null,
          });
        } else {
          this.setState({
            errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.Inconsistent')),
          });
        }
      }
    }
  }

  handleChangeRepeatPwd(value) {
    if (value === undefined || value === '') {
      this.RepeatPwd = null;
      this.setState({
        valid: false,
        errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.null')),
        RPassword: null,
      });
    } else {
      this.RepeatPwd = value.toString();
      if (this.newPwd !== value) {
        this.setState({
          valid: false,
          errmsgRPwd: this.renderErrorTips(this.intlMsg.msg('new.password.error.Inconsistent')),
          RPassword: null,
        });
      } else {
        this.setState({
          valid: true,
          RPassword: value,
          errmsgRPwd: null,
        });
      }
    }
  }

  renderErrorTips(msg) {
    return (
      <div styleName="errortips-wrapper">
        <div styleName="errortips">
          <i className="fa fa-exclamation-circle" aria-hidden="true" />&nbsp;
          {msg}
        </div>
      </div>
    );
  }

  render() {
    const { errmsgNPwd, errmsgRPwd } = this.state;
    let status = false;
    if (errmsgNPwd !== null || errmsgRPwd !== null) {
      status = true;
    }
    return (
      <div styleName="wrapper" style={{ minHeight: window.innerHeight }}>
        <h1>
          {this.intlMsg.msg('new.title.resetpwd')}
        </h1>
        <div>
          <div styleName="wrapper-form">
            <Panel bsStyle="aisz-white">
              <div styleName="form-wrapper">
                <Form horizontal>
                  <FormGroup>
                    <Col md={3} componentClass={ControlLabel}>
                      {this.intlMsg.msg('new.label.newpassword')}
                    </Col>
                    <Col md={6}>
                      <FormControl
                        bsClass="aisz-form-control-f"
                        type="password"
                        required
                        placeholder={this.intlMsg.msg('new.placeholder.newpassword')}
                        onChange={e => this.handleChangeNewPwd(e.target.value.trim())}
                      />
                      {errmsgNPwd}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col md={3} componentClass={ControlLabel}>
                      {this.intlMsg.msg('new.label.repeatpwd')}
                    </Col>
                    <Col md={6}>
                      <FormControl
                        bsClass="aisz-form-control-f"
                        type="password"
                        required
                        placeholder={this.intlMsg.msg('new.placeholder.repeatpwd')}
                        onChange={e => this.handleChangeRepeatPwd(e.target.value.trim())}
                      />
                      {errmsgRPwd}
                    </Col>
                  </FormGroup>
                  <FormGroup>
                    <Col md={6} mdOffset={3}>
                      <span styleName="submit">
                        <ActionButton
                          icon={<i className="fa fa-sign-in" aria-hidden="true" />}
                          label={this.intlMsg.msg('new.button.label')}
                          successLabel={this.intlMsg.msg('new.button.successlabel')}
                          failedLabel={this.intlMsg.msg('new.resetfailed')}
                          status={this.state.submitStatus}
                          disabled={status}
                          onClick={() => this.handleSave()}
                          onStatusReset={() => this.setState({ submitStatus: 'ready' })}
                        />
                      </span>&nbsp;
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null,
  mapDispatchToProps,
  )(injectIntl(
    CSSModules(ResetPassword, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/User/ResetPassword/index.jsx